// A1 - Ünite 5: Imperatives (Emir Cümleleri)
// Hedef: Olumlu/olumsuz emirler, güvenlik talimatları

export const A1_UNIT_5 = {
  'A1-U5-L1': {
    id: 'A1-U5-L1',
    title: 'Olumlu Emirler (Sit down, Listen)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Emir Cümleleri (Imperatives)',
          explanation: 'Emir cümleleri fiil ile başlar. Özne (you) söylenmez. Talimat, emir ve yönlendirme için kullanılır.',
          table: {
            headers: ['Fiil', 'Emir', 'Türkçesi'],
            rows: [
              ['sit', 'Sit down.', 'Oturun.'],
              ['listen', 'Listen carefully.', 'Dikkatle dinleyin.'],
              ['look', 'Look at this.', 'Buna bakın.'],
              ['fasten', 'Fasten your seatbelt.', 'Emniyet kemerinizi bağlayın.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Uçakta Kullanılan Emirler',
          table: {
            headers: ['Emir', 'Türkçesi', 'Durum'],
            rows: [
              ['Fasten your seatbelt.', 'Emniyet kemerinizi bağlayın.', 'Güvenlik'],
              ['Put your tray table up.', 'Tepsi masasını kaldırın.', 'Kalkış'],
              ['Stow your luggage.', 'Bagajınızı yerleştirin.', 'Biniş'],
              ['Follow me.', 'Beni takip edin.', 'Yönlendirme'],
              ['Take your seat.', 'Yerinize oturun.', 'Kalkış']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Emir cümlelerinde özne kullanılmaz. Doğrudan fiil ile başlar: "Sit" ("You sit" değil!)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '_____ your seatbelt.',
          options: ['Fasten', 'You fasten', 'Fastens', 'Fastening'],
          correct: 'Fasten',
          explanation: 'Emir cümlesinde fiil ile başlanır'
        },
        {
          type: 'fillInBlank',
          sentence: '_____ (sit) down, please.',
          answer: 'Sit',
          hint: 'Emir cümlesi - fiil kök hali'
        },
        {
          type: 'matching',
          instruction: 'Emirleri eşleştirin',
          pairs: [
            { left: 'Fasten', right: 'your seatbelt' },
            { left: 'Put', right: 'your bag under the seat' },
            { left: 'Follow', right: 'me' }
          ]
        }
      ]
    }
  },
  'A1-U5-L2': {
    id: 'A1-U5-L2',
    title: "Olumsuz Emirler (Don't...)",
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Olumsuz Emir',
          explanation: 'Olumsuz emir cümlesi "Don\'t" ile başlar. "Do not" kısaltmasıdır.',
          table: {
            headers: ['Olumlu', 'Olumsuz'],
            rows: [
              ['Sit down.', "Don't stand up."],
              ['Open the window.', "Don't open the door."],
              ['Use the restroom.', "Don't use during landing."]
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Uçuş Yasakları',
          table: {
            headers: ['Olumsuz Emir', 'Türkçesi', 'Sebep'],
            rows: [
              ["Don't smoke.", 'Sigara içmeyin.', 'Yasak'],
              ["Don't unfasten your seatbelt.", 'Kemerizi açmayın.', 'Güvenlik'],
              ["Don't stand up during takeoff.", 'Kalkışta ayakta kalmayın.', 'Güvenlik'],
              ["Don't use electronic devices.", 'Elektronik cihaz kullanmayın.', 'Kalkış/iniş'],
              ["Don't block the exit.", 'Çıkışı kapamayın.', 'Güvenlik']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "Don\'t" yerine "Please don\'t" kullanmak daha nazik olur.'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '_____ smoke on the aircraft.',
          options: ["Don't", 'Not', "Doesn't", 'No'],
          correct: "Don't",
          explanation: "Olumsuz emir 'Don't' ile başlar"
        },
        {
          type: 'fillInBlank',
          sentence: "_____ (not/stand) up during landing.",
          answer: "Don't stand",
          hint: "Olumsuz emir"
        },
        {
          type: 'matching',
          instruction: 'Olumlu ve olumsuz emirleri eşleştirin',
          pairs: [
            { left: 'Sit down', right: "Don't stand up" },
            { left: 'Fasten seatbelt', right: "Don't unfasten" },
            { left: 'Use restroom', right: "Don't use during landing" }
          ]
        }
      ]
    }
  },
  'A1-U5-L3': {
    id: 'A1-U5-L3',
    title: 'Nazik Emirler (Please...)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Please ile Nazik Emirler',
          explanation: '"Please" emri daha nazik yapar. Başa veya sona eklenebilir.',
          table: {
            headers: ['Normal', 'Nazik (başta)', 'Nazik (sonda)'],
            rows: [
              ['Sit down.', 'Please sit down.', 'Sit down, please.'],
              ['Wait here.', 'Please wait here.', 'Wait here, please.'],
              ['Follow me.', 'Please follow me.', 'Follow me, please.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Profesyonel Kabin Anonsu',
          table: {
            headers: ['Cümle', 'Türkçesi'],
            rows: [
              ['Ladies and gentlemen, please fasten your seatbelts.', 'Bay ve bayanlar, lütfen emniyet kemerlerinizi bağlayın.'],
              ['Please remain seated.', 'Lütfen oturmuş olarak kalın.'],
              ['Please turn off your electronic devices.', 'Lütfen elektronik cihazlarınızı kapatın.'],
              ['Please stow your tray tables.', 'Lütfen tepsi masalarınızı kaldırın.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Profesyonel ortamda her zaman "please" kullanın!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '_____ fasten your seatbelt.',
          options: ['Please', 'Do', 'Can', 'Be'],
          correct: 'Please',
          explanation: 'Nazik emir'
        },
        {
          type: 'fillInBlank',
          sentence: 'Turn off your phone, _____.',
          answer: 'please',
          hint: 'Nazik ek - sonda'
        },
        {
          type: 'matching',
          instruction: 'Anonslari eşleştirin',
          pairs: [
            { left: 'Please fasten', right: 'your seatbelt' },
            { left: 'Please remain', right: 'seated' },
            { left: 'Please turn off', right: 'electronic devices' }
          ]
        }
      ]
    }
  },
  'A1-U5-L4': {
    id: 'A1-U5-L4',
    title: "Let's... (Birlikte yapalım)",
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Let\'s - Birlikte Yapalım',
          explanation: '"Let\'s" (Let us) birlikte bir şey yapmayı önermek için kullanılır.',
          table: {
            headers: ['Yapı', 'Örnek', 'Türkçesi'],
            rows: [
              ["Let's + fiil", "Let's go.", 'Gidelim.'],
              ["Let's + fiil", "Let's start.", 'Başlayalım.'],
              ["Let's not + fiil", "Let's not wait.", 'Beklemeyelim.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Ekip İçi Kullanım',
          table: {
            headers: ['Cümle', 'Türkçesi', 'Durum'],
            rows: [
              ["Let's start the safety demonstration.", 'Güvenlik gösterimine başlayalım.', 'Kalkış'],
              ["Let's check the cabin.", 'Kabini kontrol edelim.', 'Kontrol'],
              ["Let's prepare for landing.", 'İnişe hazırlanalım.', 'İniş'],
              ["Let's go to the briefing.", 'Brifinge gidelim.', 'Hazırlık']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "Let\'s" ekip çalışmasında sık kullanılır!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '_____ start the briefing.',
          options: ["Let's", 'Let', 'Lets', "Let's not"],
          correct: "Let's",
          explanation: "Birlikte yapalım = Let's"
        },
        {
          type: 'fillInBlank',
          sentence: "_____ (let/check) the emergency equipment.",
          answer: "Let's check",
          hint: "Birlikte yapalım"
        },
        {
          type: 'matching',
          instruction: 'Önerileri tamamlayın',
          pairs: [
            { left: "Let's start", right: 'the demonstration' },
            { left: "Let's check", right: 'the cabin' },
            { left: "Let's prepare", right: 'for landing' }
          ]
        }
      ]
    }
  },
  'A1-U5-L5': {
    id: 'A1-U5-L5',
    title: 'Uygulama: Güvenlik Anonsu',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '✈️ Tam Güvenlik Anonsu',
          explanation: 'Kalkış öncesi güvenlik anonsu:',
          table: {
            headers: ['Cümle', 'Türkçesi'],
            rows: [
              ['Ladies and gentlemen, welcome aboard.', 'Bay ve bayanlar, uçağımıza hoş geldiniz.'],
              ['Please fasten your seatbelts.', 'Lütfen emniyet kemerlerinizi bağlayın.'],
              ['Please put your seats in the upright position.', 'Lütfen koltuğunuzu dik konuma alın.'],
              ['Please stow your tray tables.', 'Lütfen tepsi masalarınızı kaldırın.'],
              ['Please turn off all electronic devices.', 'Lütfen tüm elektronik cihazları kapatın.'],
              ['Please pay attention to the safety demonstration.', 'Lütfen güvenlik gösterimine dikkat edin.'],
              ['Thank you for your attention.', 'İlginiz için teşekkürler.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Güvenlik anonsu yaparken net, yavaş ve anlaşılır konuşun!'
        },
        {
          type: 'vocabulary',
          title: '✈️ Anons Kelimeleri',
          words: [
            { en: 'welcome aboard', tr: 'hoş geldiniz', pronunciation: '/ˈwelkəm əˈbɔːd/' },
            { en: 'upright position', tr: 'dik konum', pronunciation: '/ˈʌpraɪt pəˈzɪʃn/' },
            { en: 'tray table', tr: 'tepsi masası', pronunciation: '/treɪ ˈteɪbl/' },
            { en: 'attention', tr: 'dikkat', pronunciation: '/əˈtenʃn/' },
            { en: 'demonstration', tr: 'gösteri', pronunciation: '/ˌdemənˈstreɪʃn/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'fillInBlank',
          sentence: 'Ladies and gentlemen, _____ fasten your seatbelts.',
          answer: 'please',
          hint: 'Nazik emir'
        },
        {
          type: 'fillInBlank',
          sentence: '_____ turn off all electronic devices.',
          answer: 'Please',
          hint: 'Nazik emir - başta'
        },
        {
          type: 'multipleChoice',
          question: 'Put your seats in the _____ position.',
          options: ['upright', 'up right', 'upward', 'upper'],
          correct: 'upright',
          explanation: 'Upright position = dik konum'
        },
        {
          type: 'speaking',
          instruction: 'Güvenlik anonsu yapın:',
          phrases: [
            'Welcome aboard',
            'Please fasten your seatbelts',
            'Please turn off electronic devices',
            'Thank you for your attention'
          ]
        }
      ]
    }
  },
  'A1-U5-EXAM': {
    id: 'A1-U5-EXAM',
    title: 'Ünite 5 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: '_____ your seatbelt.',
        options: ['Fasten', 'You fasten', 'Fastens', 'To fasten'],
        correct: 'Fasten',
        explanation: 'Emir cümlesi fiil ile başlar'
      },
      {
        type: 'multipleChoice',
        question: '_____ smoke on the plane.',
        options: ["Don't", 'Not', "Doesn't", 'No'],
        correct: "Don't",
        explanation: "Olumsuz emir = Don't + fiil"
      },
      {
        type: 'multipleChoice',
        question: '_____ fasten your seatbelt. (nazik)',
        options: ['Please', 'Do', 'Must', 'Can'],
        correct: 'Please',
        explanation: 'Nazik emir = Please + fiil'
      },
      {
        type: 'multipleChoice',
        question: '_____ start the safety demonstration.',
        options: ["Let's", 'Let', 'Lets', "Let us don't"],
        correct: "Let's",
        explanation: "Birlikte yapalım = Let's + fiil"
      },
      {
        type: 'fillInBlank',
        sentence: '_____ (not/stand) up during takeoff.',
        answer: "Don't stand",
        hint: 'Olumsuz emir'
      },
      {
        type: 'matchPairs',
        instruction: 'Emir türlerini eşleştirin',
        pairs: [
          { left: 'Sit down.', right: 'Olumlu emir' },
          { left: "Don't stand.", right: 'Olumsuz emir' },
          { left: 'Please sit.', right: 'Nazik emir' },
          { left: "Let's sit.", right: 'Öneri' }
        ]
      }
    ]
  }
};

export default A1_UNIT_5;
